import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  CentraisOperacaoDropdown,
  CustomCheckbox,
  CustomModal,
  CustomPanel,
  InputText,
  Loading,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { withRouter } from 'react-router-dom'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  getLocaisDescarga,
  saveLocalDescarga,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'

function LocalDescarga({ history, dispatch }) {
  // Var
  const initLocal = {
    name: '',
    activated: 1,
    operationcenter_id: null,
  }
  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [locais, setLocais] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [selectedLocal, setSelectedLocal] = useState(initLocal)
  const [selectedCentral, setSelectedCentral] = useState('')
  useEffect(() => {
    if (selectedCentral !== '') {
      fetchLocaisDescarga()
    } else {
      setIsLoading(false)
    }
  }, [selectedCentral])

  // Events
  const onBtnNovoClick = () => {
    if (selectedCentral === '') {
      dispatch(showMessageBox(null, 'Selecione a Central de Operações'))
    } else {
      const newSelectedLocal = { ...selectedLocal, operationcenter_id: selectedCentral }
      setSelectedLocal(newSelectedLocal)
      setShowModal(true)
    }
  }

  const onMenuItemClicked = (menuItem, local) => {
    if (menuItem === 'Editar') {
      setSelectedLocal(local)
      setShowModal(true)
    }
  }

  const onModalSuccess = local => {
    const index = locais.findIndex(l => l.id === local.id)
    if (index !== -1) {
      const editLocais = [...locais]
      editLocais[index] = local
      setLocais([...editLocais])
    } else {
      setLocais([...locais, local])
    }
    setShowModal(false)
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
    setShowModal(false)
  }

  const onModalClose = () => setShowModal(false)

  // Helpers
  const fetchLocaisDescarga = async () => {
    try {
      const fetchedLocais = await getLocaisDescarga(selectedCentral)
      setLocais(fetchedLocais)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  //Render
  return (
    <React.Fragment>
      <PageHeader>5.3 - Local de Descarga</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovoClick} onVoltar={() => history.goBack()}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <>
              <div className="p-grid">
                <div className="p-col-4">
                  <CentraisOperacaoDropdown
                    value={selectedCentral}
                    onChange={value => setSelectedCentral(value)}
                  />
                </div>
              </div>
              <div>
                <MyDataTable locais={locais} onMenuItemClicked={onMenuItemClicked} />
              </div>
            </>
          )}
        </CustomPanel>
        {showModal ? (
          <Modal
            selectedLocal={selectedLocal}
            onModalSuccess={onModalSuccess}
            onModalError={onModalError}
            onModalClose={onModalClose}
          />
        ) : null}
      </div>
    </React.Fragment>
  )
}

function Modal({ selectedLocal, onModalClose, onModalSuccess, onModalError }) {
  // Hooks
  const [local, setLocal] = useState(selectedLocal)
  const [isLoading, setIsLoading] = useState(false)

  // Events
  const onBtnSalvar = async () => {
    try {
      setIsLoading(true)
      const savedLocal = await saveLocalDescarga(local)
      onModalSuccess(savedLocal)
    } catch (e) {
      onModalError(e)
    }
  }
  const onFormContentChange = (name, value) => {
    const newLocal = { ...local }
    newLocal[name] = value
    setLocal(newLocal)
  }

  // Render
  return (
    <CustomModal
      header={local.name === '' ? 'Novo Local de Descarga' : 'Editar Local de Descarga'}
      isVisible={true}
      onClose={onModalClose}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Nome :"
            marginTop={10}
            value={local.name}
            onChange={value => onFormContentChange('name', value)}
          />
        </div>
        <div className="p-col-12">
          <CustomCheckbox
            checked={local.activated === 1}
            onChange={value => onFormContentChange('activated', value ? 1 : 0)}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onBtnSalvar}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

function MyDataTable({ locais, onMenuItemClicked }) {
  // Render
  return (
    <DataTable emptyMessage="Nenhum Local de Descarga Cadastrado" value={locais}>
      <Column field="id" header="Cód." style={tableCellCentered(50)} />
      <Column field="name" header="Local de Descarga" />
      <Column
        field="activated"
        header="Ativo"
        style={tableCellCentered(100)}
        body={local => <CustomCheckbox disabled={true} checked={local.activated === 1} />}
      />
      <Column
        header="Menu"
        style={tableCellCentered(70)}
        body={local => (
          <ThreeDots items={['Editar']} onClick={item => onMenuItemClicked(item, local)} />
        )}
        bodyStyle={tableCellCentered()}
      />
    </DataTable>
  )
}

export default connect()(withRouter(LocalDescarga))
